import "./index.scss";
import { CfCard04Props } from "./types";
import { GeneralSmallArrowRight } from "@wise-emotions/react-icons";
import CfImageIcon from "components/ImageIcon/CfImageIcon";
import IconWrap from "components/Icon/IconWrap";
import React from "react";
import classNames from "classnames";
import parse from "html-react-parser";

const Card04 = ({
  headType,
  label,
  title,
  tags = [],
  abstract,
  image,
  labelCta,
}: CfCard04Props) => {
  const cardClassName = classNames("Card04", {
    "box-shadow-card--hasHover box-shadow-card": !!labelCta,
  });

  const text = abstract?.abstract || "";
  const cta = labelCta?.[0]?.text?.text;
  const imageIcon = image[0];

  return (
    <div className={cardClassName}>
      <div className="Card04__wrapper">
        <div data-testid="image" className="Card04__iconsection">
          <CfImageIcon {...imageIcon} />
        </div>
        <div className="Card04__textwrapper">
          <div className="Card04__title">{parse(title || "")}</div>
          {tags && tags.length > 0 && (
            <div data-testid="tags" className="Card04__tags">
              {tags.map((tag) => {
                return <span key={tag}>{`#${tag}`}</span>;
              })}
            </div>
          )}
          <div className="Card04__text">{parse(text)}</div>
          {cta && (
            <div className="Card04__cta">
              <span>{cta}</span>
              <IconWrap>
                <GeneralSmallArrowRight />
              </IconWrap>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Card04;
